import { useNavigate } from "react-router-dom";
import { Calendar, ExternalLink, Tag } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const NewsCard = ({ article }) => {
  const navigate = useNavigate();

  const publishedDate = format(new Date(article.published_date), "d MMM yyyy", { locale: ptBR });
  const excerpt = article.rewritten_content.substring(0, 150) + "...";

  return (
    <div
      className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-6 transition-all hover:shadow-lg hover:border-emerald-500/30 news-card-hover cursor-pointer"
      onClick={() => navigate(`/news/${article.id}`)}
      data-testid="news-card"
    >
      {/* Category Badge */}
      <div className="flex items-center justify-between mb-4">
        <span 
          className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-mono uppercase tracking-widest bg-emerald-900 text-white"
          data-testid="news-card-category"
        >
          <Tag className="w-3 h-3" />
          {article.category}
        </span>
        <span className="text-xs text-slate-500 flex items-center gap-1" data-testid="news-card-date">
          <Calendar className="w-3 h-3" />
          {publishedDate}
        </span>
      </div>

      {/* Title */}
      <h3 
        className="text-2xl font-semibold tracking-tight text-slate-900 mb-3 group-hover:text-emerald-900 transition-colors"
        data-testid="news-card-title"
      >
        {article.title}
      </h3>

      {/* Excerpt */}
      <p className="text-base leading-relaxed text-slate-600 mb-4" data-testid="news-card-excerpt">
        {excerpt}
      </p>

      {/* Source */}
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-500" data-testid="news-card-source">
          Fonte: {article.source}
        </span>
        <div className="flex items-center gap-1 text-emerald-900 font-medium text-sm opacity-0 group-hover:opacity-100 transition-opacity">
          Ler mais
          <ExternalLink className="w-4 h-4" />
        </div>
      </div>
    </div>
  );
};

export default NewsCard;